export default "__VITE_ASSET__e93fe43b__"